import type { ConceptDef } from '../types';

export const handwashing: ConceptDef = {
  kind: 'sequenceTap',
  id: 'handwashing',
  label: 'Handwashing Steps',
  category: 'Daily living',
  description: 'Tap handwashing steps in order.',
  config: {
    promptMode: 'AUDIO',
    sequences: [
      { label: 'Wash your hands.', items: ['💧 wet', '🧼 soap', '🤲 scrub', '💦 rinse', '🧻 dry'] },
    ],
  },
};
